type PropsType = {
  record: any
  translate: Function
  style?: any
}

export default {
  list: { lazy: () => import('./Adders'), component: 'AddersList' },
  edit: { lazy: () => import('./Adders'), component: 'AddersEdit' },
  create: { lazy: () => import('./Adders'), component: 'AddersCreate' },
  options: {
    create: {
      title: 'Create Adder',
      subtitle: null,
      breadCrumb: 'Create Adder',
    },
    list: {
      title: 'Adders Library',
      subtitle: null,
      breadCrumb: 'Adders Library',
    },
    edit: {
      title: 'Edit Adder',
      subtitle: null,
      breadCrumb: 'Edit Adder',
    },
  },
}
